import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api.ts';

export function AdminDashboard() {
  const boats = useQuery({ queryKey: ['boats', false], queryFn: () => api.listBoats(false) });
  const races = useQuery({ queryKey: ['admin-races'], queryFn: () => api.listRaces() });

  const upcoming = (races.data ?? []).filter(
    (r) => r.status === 'scheduled' || r.status === 'postponed',
  );
  const live = (races.data ?? []).filter((r) => r.status === 'started');

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Oversikt</h2>
      <div className="grid grid-cols-2 gap-3 mb-6">
        <StatCard label="Båter" value={boats.data?.length ?? 0} to="/admin/boats" />
        <StatCard label="Kommende regattaer" value={upcoming.length} to="/admin/races" />
        <StatCard label="Pågår nå" value={live.length} to="/admin/races" highlight={live.length > 0} />
        <StatCard
          label="Totalt regattaer"
          value={races.data?.length ?? 0}
          to="/admin/races"
        />
      </div>

      {upcoming.length > 0 && (
        <section className="bg-slate-900/40 border border-slate-800 rounded-xl p-4">
          <h2 className="font-semibold mb-2">Kommende</h2>
          <ul className="divide-y divide-slate-800">
            {upcoming.slice(0, 5).map((r) => (
              <li key={r.id} className="py-2">
                <Link to={`/admin/races/${r.id}`} className="flex justify-between items-center">
                  <span className="truncate">{r.name}</span>
                  <span className="text-xs text-slate-500 font-mono">
                    {new Date(r.startTime).toLocaleString('no-NO', {
                      dateStyle: 'short',
                      timeStyle: 'short',
                      timeZone: 'Europe/Oslo',
                    })}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}

function StatCard({
  label,
  value,
  to,
  highlight,
}: {
  label: string;
  value: number;
  to: string;
  highlight?: boolean;
}) {
  return (
    <Link
      to={to}
      className={`
        block rounded-xl p-4 border
        ${highlight
          ? 'bg-emerald-900/30 border-emerald-700'
          : 'bg-slate-900/40 border-slate-800'}
      `}
    >
      <div className="text-2xl font-bold">{value}</div>
      <div className="text-xs text-slate-400">{label}</div>
    </Link>
  );
}
